<template>
  <div class="team">
    <Banner />
    <div style="height: 120px"></div>
    <div class="container">
      <div class="tips flex">
        <div class="icon">
          <img :src="require('@/assets/5101/icon_14.png')" alt="">
        </div>
        <div class="txt flex-item">文化社团</div>
        
      </div>
      <div class="items flex">
        <div class="item flex" v-for="v in listData" :key="v.id" @click="jump(v)">
          <div class="cover">
            <el-image 
              style="width: 100%; height: 120px"
              :src="isHead(v.img)" 
              fit="cover">
              <template #placeholder>
                <el-image 
                  style="width: 100%; height: 120px"
                  :src="isHead()" 
                  fit="cover">
                </el-image>
              </template>
            </el-image>
          </div>
          <div class="info-box">
            <div class="title ellipsis">{{v.name}}</div>
            <div class="txt ellipsis">负责人：{{v.linkman}}</div>
            <div class="txt ellipsis">联系电话：{{v.tel}}</div>
            <div class="more flex">
              <div class="p1">查看详情</div>
              <div class="icon">
                <img :src="require('@/assets/5101/icon_5.png')" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tip-box flex">
        <el-divider v-show="loading && !isOver"><el-button :loading="true">加载中</el-button></el-divider>
        <el-divider v-show="!loading && !isOver"><el-button size="small" @click="getList()">加载更多</el-button></el-divider>
        <el-divider v-show="!loading && isOver">已全部加载</el-divider>
      </div>
    </div>
    <div style="height: 120px"></div>
  </div>
</template>

<script>
import { reactive, toRefs } from "vue"
import { api } from "@/api"
import { isHead } from "@/tools"
import { useRouter } from "vue-router"
import Banner from "@/components/5101/index/Banner.vue"
export default {
  name: "team",
  components: {Banner},
  setup() {
    const Router = useRouter()
    let initData = reactive({
      loading: false,
      isOver: false,
      page: 1,
      listData: [],
    })
    getList()
    function getList() {
      initData.loading = true
      api("get", "getAppAssociationList", {type: 1, pageNum: initData.page, pageSize: 12})
        .then(res => {
          initData.loading = false
          if(res.code === 1200) {
            if(res.data) { // 数据存  处理后台返回 null
              if(initData.page == 1) { // 处理掉loading数据
                initData.listData = res.data
              } else {
                initData.listData = [ ...initData.listData, ...res.data]
              }
              // 加载完成
              if(res.data.length < 12) {
                initData.isOver = TransformStreamDefaultController
              } else {
                initData.page += 1
              }
            } else {
              initData.isOver = true
            }
          } else {
            initData.isOver = true
          }
        })
        .catch(err => {
          initData.isOver = true
          initData.loading = false

        })
    }
    function jump(row) {
      Router.push({
        path: "/show/team",
        query: {
          id: row.id
        }
      })
    }
    return {
      ...toRefs(initData),
      isHead,
      getList,
      jump
    }
  }
}
</script>

<style lang="less" scoped>
.team {
  background-color: #F6F6F6;
  .container {
    width: 1248px;
    .items {
      flex-wrap: wrap;
      margin-top: 35px;
      .item {
        width: 384px;
        height: 160px;
        margin: 24px 0 0 24px;
        background-color: #fff;
        padding: 20px 20px 20px 15px;
        box-sizing: border-box;
        transition: .2s;
        cursor: pointer;
        &:hover {
          transform: scale(1.05);
          background-color: #1A2E43;
          .title {
            color: #fff;
          }
          .txt {
            color: #fff;
            opacity: .9;
          }
        }
        .cover {
          width: 120px;
          display: flex;
          align-items: center;
          font-size: 0;
          .el-image {
            border-radius: 50%;
            overflow: hidden;
          }
        }
        .info-box {
          margin-left: 15px;
          .title {
            font-weight: bold;
          }
          .txt {
            font-size: 14px;
            color: #8C96A1;
            margin-top: 12px;
          }
        }
        .more {
          margin-top: 15px;
          .p1 {
            font-size: 14px;
            color: #10BB58;
          }
          .icon {
            margin-left: 10px;
            
          }
        }
      }
    }
  }
}
.tips {
  width: 1200px;
  margin: 0 auto;
  align-items: center;
  padding-bottom: 20px;
  position: relative;
  border-bottom: 1px solid #C5C5C5;
  &::after {
    content: "";
    height: 3px;
    width: 140px;
    background-color: #1A2E43;
    position: absolute;
    left: 0;
    bottom: -2px;
    border-radius: 2px;
  }
  .icon {
    font-size: 0;
  }
  .txt {
    font-size: 26px;
    font-weight: bold;
    margin-left: 12px;
    line-height: 1;
  }
  .more {
    cursor: pointer;
    text-decoration: none;
    .p1 {
      color: #10BB58;
    }
    .cover {
      margin-left: 10px;
      .img {
        width: 27px;
      }
    }
  }
}
.tip-box {
  width: 1200px;
  height: 100px;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  
}
:deep(.el-divider__text) {
  background-color: #F6F6F6;
  color: #585858;
}
</style>